import {Component} from '@angular/core';

@Component({
    selector: 'app-why-finzy-section',
    templateUrl: './why-finzy-section.component.html',
    styleUrls: ['../../../../assets/styles/new-styles.css']
})
export class WhyFinzySectionComponent {
}
